import { createContext, Dispatch, SetStateAction, useState } from "react";
import { createCookie, EXPIRE_IN_A_YEAR, getCookie } from "../utils/cookies";

type AuthContextProviderType = {
  children: React.ReactNode;
};

export type AuthContextType = {
  isAuth: boolean;
  setIsAuth: Dispatch<SetStateAction<boolean>>;
  saveAuthCookies: (data: any) => void;
};

export const AuthContext = createContext({} as AuthContextType);
export const AuthProvider = ({ children }: AuthContextProviderType) => {
  const authCookie = getCookie(document.cookie, "refreshToken");
  const [isAuth, setIsAuth] = useState(!!authCookie);

  const saveCookies = (tokenData: any) => {
    const {
      AuthenticationResult: { AccessToken, RefreshToken, ExpiresIn },
      email,
    } = tokenData;

    const accessTokenExpInHours = ExpiresIn / 60 / 60;
    if (AccessToken) {
      createCookie("accessToken", AccessToken, accessTokenExpInHours - 1);
      setIsAuth(true);
    }
    if (RefreshToken) {
      createCookie(
        "refreshToken",
        JSON.stringify({ token: RefreshToken, email }),
        EXPIRE_IN_A_YEAR
      );
    }
  };

  return (
    <AuthContext.Provider
      value={{ isAuth, setIsAuth, saveAuthCookies: saveCookies }}
    >
      {children}
    </AuthContext.Provider>
  );
};
